import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../utils/translator.helper';
import { ThemeController } from '@nirvana/shared/color-theme';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { Theme } from 'libs/shared/color-theme/src/lib/types';

/**
 * @summary This component it's used only in SB to toggle darkmode
 */

@customElement('gz-dark-mode-toggle')
export class GzDarkModeToggleWebComponent extends LitElement {
  private themeController: ThemeController;

  static get styles() {
    return styles;
  }

  constructor() {
    super();
    this.themeController = new ThemeController(this);
  }

  render() {
    return html`
      <gz-toggle gz-form-input @toggleChange="${this.handleDarkTheme}"
        >${translateFn('Dark theme')}</gz-toggle
      >
    `;
  }

  private handleDarkTheme(event: CustomEvent) {
    const currentTheme = this.themeController.theme;
    let newTheme: Theme;

    switch (currentTheme) {
      case Theme.AUTO:
      case Theme.LIGHT:
        newTheme = Theme.DARK;
        break;
      case Theme.DARK:
        newTheme = Theme.LIGHT;
        break;
      default:
        newTheme = Theme.AUTO;
    }

    this.themeController.setTheme(newTheme);
    document.bgColor = newTheme === Theme.DARK ? '#0E131A' : '#ffffff';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-dark-mode-toggle': GzDarkModeToggleWebComponent;
  }
}
